import classNames from 'classnames'

import styles from './index.module.css'

import '@blocknote/core/fonts/inter.css'
import '@blocknote/mantine/style.css'

interface Props {
  className?: string
  value: string
}

const RenderedHtml = ({ className, value }: Props) => (
  <div
    className={classNames(styles.container, className)}
    dangerouslySetInnerHTML={{ __html: value }}
  />
)

export default RenderedHtml
